export default function recommendationTemplate(profiles, mode) {
    return `
<h2 class="u-t3 u-mb16">Bli kjent med din neste arbeidsgiver</h2>
<div class="ad-stream grid grid--cols1upto640 grid--cols3upto990 grid--cols3from990">
    ${profiles.map(({ baseUrl, imagesCdnUrl, id, imagePath, companyName, logo }) =>
    `<div class="ad-stream__unit grid__unit">
        <article class="ad-preview">
        <a href="${baseUrl}/job/employer/company/${id}" class="ad-preview__click-area tracked-recommended-employer-profile" data-recommendation data-mode="${mode}">
            <div class="ad-preview__media">
            <div class="img-format img-format--ratio4by3 img-format--centered img-format--crop-horizontal">
                        <img
                            class="img-format__img"
                            src="${imagesCdnUrl}/dynamic/480x360c/${imagePath}"
                            srcset="${imagesCdnUrl}/dynamic/480x360c/${imagePath} 480w,
                                    ${imagesCdnUrl}/dynamic/240x180c/${imagePath} 240w,
                                    ${imagesCdnUrl}/dynamic/320x240c/${imagePath} 320w,
                                    ${imagesCdnUrl}/dynamic/640x480c/${imagePath} 640w,
                                    ${imagesCdnUrl}/dynamic/960x720c/${imagePath} 960w"
                            sizes="(min-width: 640px) 33vw, 100vw"
                            alt=""
                        >
                    </div>
                </div>
                <div class="ad-preview__text company-description">
                    <div class="company-description__text">
                        <p class="ad-stream__location">
                            Bli bedre kjent med
                        </p>
                        <h3 class="ad-stream__description" title="${companyName}">
                            ${companyName}
                        </h3>
                    </div>
                    <img class="company-description__logo" src="${logo}" alt="">
                </div>
            </a>
        </article>
    </div>`
    ).join('')}
</div>`.trim();
}
